import React, { useEffect, useState, useContext, useRef } from "react";
import appConst from "../Utilities/appConst.json";
import "../styles/summary.css";
import Accordion from "../shared/Accordion";
import { LanguageContext } from "../context/language/LanguageContext";
import FooterDetialsItems from "./FooterDetialsItems";
import { ChevronDown } from "lucide-react";
import { useDispatch } from "react-redux";
import { footerActions } from "../store/footerSlice";
import { getLanguageDirection } from "../Utilities/languageDirection";

const FooterDetialsAccordion = () => {
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const direction = getLanguageDirection(languageContext?.language?.id);
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef(null);

  const handleAccordionChange = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (!isExpanded) {
      dispatch(footerActions.setFooterContentHeight(0));
      return;
    }

    let observer;
    const rafId = requestAnimationFrame(() => {
      const element = contentRef.current;
      if (!element) return;

      observer = new ResizeObserver(() => {
        if (contentRef.current) {
          dispatch(
            footerActions.setFooterContentHeight(
              contentRef.current.clientHeight
            )
          );
        }
      });
      observer.observe(element);
    });

    return () => {
      cancelAnimationFrame(rafId);
      observer?.disconnect();
    };
  }, [isExpanded]);

  return (
    <div className="background_cultured" data-testid="footer-summary-accordion">
      <Accordion
        onChange={handleAccordionChange}
        expandedPanel={isExpanded}
        icon={<ChevronDown size={20} />}
        className={"color_black"}
        accordionSummary={
          <div
            className="color_black"
            data-testid="footer-summary-accordion-trigger"
            style={{
              direction,
              width: "100%",
              fontFamily: "Lupa PLONI MEDIUM",
              textAlign: "start",
            }}
          >
            {languageContext.getTranslation(
              appConst.ACCORDION_BUTTON_SUMMARY_FOOTER_TEXT
            )}
          </div>
        }
        accordionDetails={<FooterDetialsItems />}
        contentRef={contentRef}
      />
    </div>
  );
};
export default FooterDetialsAccordion;
